// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AutocompleteV5 = require("../autocomplete/AutocompleteV5.bs.js");
let AccountMemberRole = require("../common/AccountMemberRole.bs.js");
let JsxRuntime = require("react/jsx-runtime");

let roleInputToString = AccountMemberRole.toString;

function roleOutputToString(x) {
  if (x !== "ASSISTANT" && x !== "UNKNOWN" && x !== "ASSOCIATE" && x !== "TRANSACTION_COORDINATOR" && x !== "BUYER_SPECIALIST" && x !== "SHOWING_ASSISTANT" && x !== "CLIENT_CARE_COORDINATOR" && x !== "PARTNER" && x !== "INSIDE_SALES_AGENT" && x !== "OWNER" && x !== "LISTING_MANAGER" && x !== "OPERATIONS_MANAGER" && x !== "LISTING_SPECIALIST" && x !== "MARKETING_SPECIALIST") {
    return "Unknown";
  }
  switch (x) {
    case "ASSISTANT" :
      return "Assistant";
    case "ASSOCIATE" :
      return "Associate";
    case "BUYER_SPECIALIST" :
      return "Buyer Specialist";
    case "CLIENT_CARE_COORDINATOR" :
      return "Client Care Coordinator";
    case "INSIDE_SALES_AGENT" :
      return "Inside Sales Agent";
    case "LISTING_MANAGER" :
      return "Listing Manager";
    case "LISTING_SPECIALIST" :
      return "Listing Specialist";
    case "MARKETING_SPECIALIST" :
      return "Marketing Specialist";
    case "OPERATIONS_MANAGER" :
      return "Operations Manager";
    case "OWNER" :
      return "Owner";
    case "PARTNER" :
      return "Partner";
    case "SHOWING_ASSISTANT" :
      return "Showing Assistant";
    case "TRANSACTION_COORDINATOR" :
      return "Transaction Coordinator";
    case "UNKNOWN" :
      return "Unknown";
  }
}

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return AccountMemberRole.toString(x.value);
}

function make(value) {
  return {
    value: value,
    label: AccountMemberRole.toString(value)
  };
}

let defaultValues = [
  "ASSISTANT",
  "ASSOCIATE",
  "BUYER_SPECIALIST",
  "CLIENT_CARE_COORDINATOR",
  "INSIDE_SALES_AGENT",
  "LISTING_MANAGER",
  "LISTING_SPECIALIST",
  "MARKETING_SPECIALIST",
  "OPERATIONS_MANAGER",
  "PARTNER",
  "SHOWING_ASSISTANT",
  "TRANSACTION_COORDINATOR"
];

let options = defaultValues.map(v => ({
  value: v,
  label: AccountMemberRole.toString(v)
}));

let SelectOpts = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  make: make,
  defaultValues: defaultValues,
  options: options
};

function AccountMemberUtils$RoleSelectComponent(props) {
  let result = props.result;
  return JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    onChange: props.onChange,
    options: options,
    value: props.value,
    status: result !== undefined ? (
        result === "Error" ? "Failure" : "Success"
      ) : "Neutral"
  });
}

let RoleSelectComponent = {
  make: AccountMemberUtils$RoleSelectComponent
};

let roleToString = AccountMemberRole.toString;

exports.roleToString = roleToString;
exports.roleInputToString = roleInputToString;
exports.roleOutputToString = roleOutputToString;
exports.SelectOpts = SelectOpts;
exports.RoleSelectComponent = RoleSelectComponent;
/* options Not a pure module */
